const wavesurfers = [];
function createWaveSurferSets(sampleHandles,sampleUrls) {

  const samplesData = [sampleHandles, sampleUrls];
  
  const combinedArray = samplesData[1].map((url, index) => ({
    handle: samplesData[0][index],
    url: url,
  }));

  combinedArray.forEach((arr, i) => {
    const waveformSetsDiv = document.querySelector('product-card[handle="'+ arr.handle + '"] .product-card__wavesurfer');
    const waveformSetDiv = document.createElement("div");
    waveformSetDiv.classList.add("waveformSet");

    const container = document.createElement("div");

    const button = document.createElement("i");
    button.classList = `Waveform ${i + 1} fas fa-play`;
    button.addEventListener("click", function () {
      togglePlayPause(i, button);
    });

    container.classList.add("waveformContainer");
    container.id = `waveformContainer${i}`;

    waveformSetDiv.appendChild(button);
    waveformSetDiv.appendChild(container);

    waveformSetsDiv.appendChild(waveformSetDiv);

    const wavesurfer = WaveSurfer.create({
      container: `#waveformContainer${i}`,
      waveColor: "black",
      progressColor: "red",
      height: 40,
      hideScrollbar: true,
      mediaControls: false,
      cursorWidth: 0,
      backend: 'MediaElement'
    });
    wavesurfers.push(wavesurfer);
    wavesurfer.load(arr.url);
  });
}

function togglePlayPause(index, button) {
  const wavesurfer = wavesurfers[index];
  if (wavesurfer.isPlaying()) {
    wavesurfer.pause();
    button.classList.remove("fa-pause");
    button.classList.add("fa-play");
    button.classList.remove("red");
    button.classList.add("black");
  } else {
    stopAllExcept(index, button);
    wavesurfer.play();
    button.classList.remove("fa-play");
    button.classList.add("fa-pause");
    button.classList.remove("black");
    button.classList.add("red");
  }
  wavesurfer.on('finish', function() {
    wavesurfer.seekTo(0);
    button.classList.remove("fa-pause");
    button.classList.add("fa-play");
    button.classList.remove("red");
    button.classList.add("black");
  });
}

function stopAllExcept(indexToKeep, button) {
  wavesurfers.forEach((wavesurfer, index) => {
    if (index !== indexToKeep && wavesurfer.isPlaying()) {
      wavesurfer.stop();
      wavesurfer.seekTo(0);
      const icons = document.querySelectorAll(".fas");

      icons.forEach((icon) => {
        if (icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
          icon.classList.remove("red");
          icon.classList.add("black");
        }
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function () { 
  
  const sampleHandlesElements = document.querySelectorAll('product-card[handle]');
  const sampleHandles = Array.from(sampleHandlesElements).map(element => element.getAttribute("handle"));
  
  const sampleUrlsElements = document.querySelectorAll('product-card[handle] .product-card__wavesurfer[url]');
  const sampleUrls = Array.from(sampleUrlsElements).map(element => element.getAttribute("url"));
  
  createWaveSurferSets(sampleHandles,sampleUrls);
});

document.addEventListener('facet:update', function(event) {
  wavesurfers.forEach((wavesurfer, index) => {
    if (wavesurfer.isPlaying()) {
      wavesurfer.stop();
      wavesurfer.seekTo(0);
    }
  });
  
  setTimeout(() => {
  
    wavesurfers.length = 0;
    
    let waveformSets = document.querySelectorAll('.waveformSet');
    waveformSets.forEach((waveformSet, index) => {
      waveformSet.remove();
    });
      
    const sampleHandlesElements = document.querySelectorAll('product-card[handle]');
    const sampleHandles = Array.from(sampleHandlesElements).map(element => element.getAttribute("handle"));
    
    const sampleUrlsElements = document.querySelectorAll('product-card[handle] .product-card__wavesurfer[url]');
    const sampleUrls = Array.from(sampleUrlsElements).map(element => element.getAttribute("url"));
    
    createWaveSurferSets(sampleHandles,sampleUrls);
  }, "1000");
});

document.addEventListener("shopify:section:load", function(event) {
  wavesurfers.forEach((wavesurfer, index) => {
    if (wavesurfer.isPlaying()) {
      wavesurfer.stop();
      wavesurfer.seekTo(0);
    }
  });
  
  setTimeout(() => {
  
    wavesurfers.length = 0;
    
    let waveformSets = document.querySelectorAll('.waveformSet');
    waveformSets.forEach((waveformSet, index) => {
      waveformSet.remove();
    });
      
    const sampleHandlesElements = document.querySelectorAll('product-card[handle]');
    const sampleHandles = Array.from(sampleHandlesElements).map(element => element.getAttribute("handle"));
    
    const sampleUrlsElements = document.querySelectorAll('product-card[handle] .product-card__wavesurfer[url]');
    const sampleUrls = Array.from(sampleUrlsElements).map(element => element.getAttribute("url"));
    
    createWaveSurferSets(sampleHandles,sampleUrls);
  }, "500");
});

